import css from '@emotion/css';
import { styled, pxToRem, textStyle, Icon } from '@feast-it/ui/light';
import Link from '../Link';

export const PillButtonContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: ${theme.spacing[2]};
  `
);

export const SubtitleWrapper = styled.span(
  ({ theme }) => css`
    display: block;
    ${textStyle(theme, 'bodySmall', 'darkGrey')};
  `
);

export const StyledLink = styled(Link)(
  ({ theme }) => css`
    text-decoration: none;
    min-width: ${pxToRem(280)};
    display: flex;
    align-items: center;
    padding: ${theme.spacing[4]} ${theme.spacing[6]};
    ${textStyle(theme, 'bodyMedium', 'black')};
    white-space: nowrap;
    border: 1px solid ${theme.colors.togatherBlue};
    border-radius: ${pxToRem(100)};
    background-color: ${theme.colors.white};
    transition: background-color ${theme.transitions.short};
    gap: ${theme.spacing[2]};

    &:hover {
      background-color: ${theme.colors.lightGrey};
    }
  `
);

export const StyledIcon = styled(Icon)(
  () => css`
    flex-shrink: 0;
  `
);

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
